module.exports = {
          srcSet: __webpack_public_path__ + "262a919050bc185f7d501fc203d5e877-1748.png"+" 1748w",
          images:[ {path: __webpack_public_path__ + "262a919050bc185f7d501fc203d5e877-1748.png",width: 1748,height: 733}],
          src: __webpack_public_path__ + "262a919050bc185f7d501fc203d5e877-1748.png",
          toString:function(){return __webpack_public_path__ + "262a919050bc185f7d501fc203d5e877-1748.png"},
          
          width: 1748,
          height: 733
        }